import React, { useState, useEffect } from "react";
import SearchBar from "./components/SearchBar/SearchBar";
import CurrentWeather from "./components/CurrentWeather/CurrentWeather";
import WeatherDetails from "./components/WeatherDetails/WeatherDetails";
import Forecast from "./components/Forecast/Forecast";
import Loader from "./components/Loader/Loader";
import { fetchWeatherData, fetchForecastData } from "./services/weatherApi";
import { getWeatherBackground, isNightTime } from "./utils/weatherBackgrounds";
import "./App.css";

function App() {
  const [weatherData, setWeatherData] = useState(null);
  const [forecastData, setForecastData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [background, setBackground] = useState({
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    className: "default",
  });

  // Update background based on weather
  useEffect(() => {
    if (weatherData) {
      const { weather, sys } = weatherData;
      const isNight = isNightTime(sys.sunrise, sys.sunset);
      const newBackground = getWeatherBackground(weather[0].id, isNight);
      setBackground(newBackground);
    }
  }, [weatherData]);

  const handleSearch = async (city) => {
    setLoading(true);
    setError(null);

    try {
      const [weather, forecast] = await Promise.all([
        fetchWeatherData(city),
        fetchForecastData(city),
      ]);

      setWeatherData(weather);
      setForecastData(forecast);
    } catch (err) {
      console.error("Search error:", err);
      setError(err.message || "City not found. Please try again.");
      setWeatherData(null);
      setForecastData(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className={`app ${background.className}`}
      style={{ background: background.background }}
    >
      <div className="container">
        <header className="header">
          <h1>🌤️ Weather Dashboard</h1>
          <p>Get real-time weather updates for any city</p>
        </header>

        <SearchBar onSearch={handleSearch} />

        {loading && <Loader />}

        {error && (
          <div className="error-container">
            <span className="error-icon">😕</span>
            <p>{error}</p>
          </div>
        )}

        {weatherData && !loading && (
          <div className="dashboard">
            <CurrentWeather data={weatherData} />
            <WeatherDetails data={weatherData} />
            {forecastData && <Forecast data={forecastData} />}
          </div>
        )}

        {!weatherData && !loading && !error && (
          <div className="welcome-message">
            <span className="welcome-icon">🔍</span>
            <h2>Search for a city</h2>
            <p>Enter a city name to get started</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
